export const TranslationValues = {
	siteName: 'Information',
	listName: 'IziBiziResources',
	keyGroups: {
		global: 'global',
	},
};
